import { FC } from "react";
import styles from "./ListLayout.module.scss";
import classNames from "classnames";

export type Layout =
  | "list"
  | "grid-2"
  | "grid-3"
  | "grid-4"
  | "grid-5"
  | "grid-6";

interface ListLayoutProps {
  layout?: Layout;
  onChangeLayout?: (layout: Layout) => void;
}

const ListLayout: FC<ListLayoutProps> = ({ layout, onChangeLayout }) => {
  return (
    <div className={classNames(styles.list_layout, "hidden lg:flex")}>
      <div
        className={classNames(styles.layout_item, {
          [styles.active]: layout === "grid-2",
        })}
        onClick={() => onChangeLayout?.("grid-2")}
      >
        <svg
          width="27"
          height="26"
          viewBox="0 0 27 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="12" height="12" rx="2" />
          <rect x="14" width="12" height="12" rx="2" />
          <rect y="14" width="12" height="12" rx="2" />
          <rect x="14" y="14" width="12" height="12" rx="2" />
        </svg>
      </div>
      <div
        className={classNames(styles.layout_item, {
          [styles.active]: layout === "grid-3",
        })}
        onClick={() => onChangeLayout?.("grid-3")}
      >
        <svg
          width="41"
          height="26"
          viewBox="0 0 41 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="0.5" width="12" height="12" rx="2" />
          <rect x="14.5" width="12" height="12" rx="2" />
          <rect x="28.5" width="12" height="12" rx="2" />
          <rect x="0.5" y="14" width="12" height="12" rx="2" />
          <rect x="14.5" y="14" width="12" height="12" rx="2" />
          <rect x="28.5" y="14" width="12" height="12" rx="2" />
        </svg>
      </div>
      <div
        className={classNames(styles.layout_item, {
          [styles.active]: layout === "grid-4",
        })}
        onClick={() => onChangeLayout?.("grid-4")}
      >
        <svg
          width="55"
          height="26"
          viewBox="0 0 55 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="0.5" width="12" height="12" rx="2" />
          <rect x="14.5" width="12" height="12" rx="2" />
          <rect x="28.5" width="12" height="12" rx="2" />
          <rect x="42.5" width="12" height="12" rx="2" />
          <rect x="0.5" y="14" width="12" height="12" rx="2" />
          <rect x="14.5" y="14" width="12" height="12" rx="2" />
          <rect x="28.5" y="14" width="12" height="12" rx="2" />
          <rect x="42.5" y="14" width="12" height="12" rx="2" />
        </svg>
      </div>
    </div>
  );
};

export default ListLayout;
